'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = require('babel-helper-vue-jsx-merge-props');

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _lib = require('../../lib');

var _PropTypes = require('../../lib/PropTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SuiAdvertisement',
  description: 'An advertisement view presents thrif-party promotional content',
  mixins: [_lib.SemanticUIVueMixin],
  props: {
    centered: {
      type: Boolean,
      description: 'Center the advertisement',
      default: false
    },
    test: {
      type: [String, Number],
      description: 'Text to be displayed on the advertisement.'
    },
    unit: (0, _PropTypes.Enum)(['medium rectangle', 'large rectangle', 'small rectangle', 'vertical rectangle', 'leaderboard', 'half page', 'mobile leaderboard', 'mobile banner', 'button', 'square button', 'small button', 'skyscraper', 'wide skyscraper', 'banner', 'vertical banner', 'top banner', 'half banner', 'leaderboard', 'large leaderboard', 'billboard', 'panorama', 'netboard'], {
      description: 'Define the size of the advertisement',
      type: String,
      required: true
    })
  },
  render: function render() {
    var h = arguments[0];

    var ElementType = this.getElementType();
    return h(
      ElementType,
      (0, _babelHelperVueJsxMergeProps2.default)([this.getChildPropsAndListeners(), {
        'class': this.classes('ui', this.centered ? 'centered' : null, this.unit, this.test ? 'test' : null, 'ad'),
        attrs: { 'data-text': this.test
        }
      }]),
      [this.$slots.default]
    );
  }
};